"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _4d_mapper_1 = require("4d-mapper");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const map_event_objects_1 = require("./map-event.objects");
const veflux_1 = require("vasat/dist/src/veflux");
const identify_interface_1 = require("@src/app/xs/interfaces/identify.interface");
class ProfileEvent extends veflux_1.BaseSimpleEvent {
}
exports.ProfileEvent = ProfileEvent;
class AccountEvent extends veflux_1.BaseSimpleEvent {
}
exports.AccountEvent = AccountEvent;
class FolderEvent extends veflux_1.BaseEvent {
}
exports.FolderEvent = FolderEvent;
class FileEvent extends veflux_1.BaseEvent {
}
exports.FileEvent = FileEvent;
class ProcessingEvent extends veflux_1.BaseEvent {
}
exports.ProcessingEvent = ProcessingEvent;
class UploadEvent extends veflux_1.BaseEvent {
}
exports.UploadEvent = UploadEvent;
class ACLFeatureEvent extends veflux_1.BaseSimpleEvent {
}
exports.ACLFeatureEvent = ACLFeatureEvent;
class FileDataService {
    constructor(fourD) {
        this.fourD = fourD;
        this.__ID = identify_interface_1.XsIdentityInterface.__init(this);
        // globals (on Ready)
        this._teams = new veflux_1.ArrayStore(AccountEvent);
        this._profile = new veflux_1.Store(ProfileEvent);
        this._account = new veflux_1.Store(AccountEvent);
        this._team = new veflux_1.Store(AccountEvent);
        this._sampleAccount = new veflux_1.Store(AccountEvent);
        this._uploadingQueue = new veflux_1.ArrayStore(UploadEvent);
        this._uploadingFiles = new veflux_1.ArrayStore(UploadEvent);
        this._processingItems = new veflux_1.ArrayStore(ProcessingEvent);
        /* Should this even be here, projects loading on the fly maybe? */
        this._projects = new veflux_1.ArrayStore(map_event_objects_1.ProjectEvent);
        this._acl = new veflux_1.ArrayStore(ACLFeatureEvent);
        this.CONCURRENT_ULs = 5;
        this.initUploadQueueLogic();
    }
    onReady() {
        return this.profile.events.pipe(operators_1.filter(p => p.event == 'ADD'), operators_1.take(1));
    }
    onTeamReady() {
        return this.team.events.pipe(operators_1.filter(p => p.event == 'ADD'), operators_1.take(1));
    }
    init() {
        return this.fourD.onReady().pipe(operators_1.tap(t => {
            this.teams.values = this.fourD.teams;
            this.account.value = this.fourD.activeTeam;
            this._sampleAccount.value = this.fourD.sampleAccount;
            this.profile.value = this.fourD.activeUser;
        }));
    }
    initTeam(a) {
        if (this.team.value == a)
            return rxjs_1.of(a);
        // set to null so items can display loading screens if they need to
        this.team.value = null;
        return this.fourD.setActiveTeam(a.uid).pipe(operators_1.flatMap(_ => rxjs_1.forkJoin([
            this.fourD.V.searchByObject(_4d_mapper_1.Project).equals("account", a.id).sortBy('dateUpdated', true).useCache(true).limit(202).queryObservable().pipe(operators_1.tap(res => this.projects.values = res.items)),
            this.refreshWidgets(a)
        ])), operators_1.map(res => {
            this.team.value = a;
            return a;
        }));
    }
    refreshWidgets(a, p) {
        return this.fourD.V.api(p ? '/api/Project/' + p.id + '.access'
            :
                '/api/Account/' + (a ? a.id : (this.team && this.team.value ? this.team.value.id : 0)) + '.access').pipe(operators_1.tap(r => {
            this.acl.values = r;
        }));
    }
    destroy() {
    }
    uploadFiles(files, dest) {
        rxjs_1.concat(files.map(file => {
            var name = file.name;
            var meta = {
                name: name,
                folder: dest,
                incomplete_offset: 0,
                incomplete_seq: 0,
                incomplete_total: length,
                incomplete: true
            };
            var blank = new _4d_mapper_1.Dataset(this.fourD.V).set(meta);
            return blank.saveObservable().pipe(operators_1.map(res => {
                this.fourD.V.registerCacheClass(_4d_mapper_1.Dataset, [blank]);
                return {
                    dataset: res,
                    file: file,
                    progress: 0
                };
            })).subscribe(res => {
                if (this.uploadingFiles.values.length < this.CONCURRENT_ULs)
                    this.uploadingFiles.set(res);
                else
                    this.uploadingQueue.set(res);
            });
        })).subscribe();
    }
    /*
    job_batch_update
    Sock cast SocketCmd(job_batch_update,Map(name -> Thu Feb 27 12:27:16 AEDT 2020, job_name -> DEFAULT t, job_id -> 137, info -> processing, id -> 152, progress -> 0, status -> processing)) None
    
    */
    /**
     * Queue logic for file uploads, makes sure only a certain number of files are uplaoding at once, queuees the rest
     */
    initUploadQueueLogic() {
        this.uploadingFiles.events.subscribe(ev => {
            // when file is queued, construct the actual upload to server
            if (ev.event == 'ADD') {
                var c = new _4d_mapper_1.ChunkedFileUploader(this.fourD.V, this.fourD.V.config.host +
                    '/api/Dataset/' + ev.item.dataset.id + '.chunked/' + ev.item.file.name, 15000000);
                ev.item.uploader = c;
                c.progressObservable.subscribe(s => {
                    ev.item.progress = s;
                    this.uploadingFiles.emmit(ev.item, 'UPDATE', { progress: s });
                });
                c.uploadObservable(ev.item.file).subscribe(s => {
                    if (s.finished) {
                        this.uploadingFiles.emmit(ev.item, 'upload_finished', s);
                        if (s.status == 204) {
                            this.processingItems.add({
                                task: ev.item.dataset,
                                progress: 1,
                                status: 'Detecting File Type'
                            });
                        }
                    }
                    else {
                        this.uploadingFiles.emmit(ev.item, 'upload_error', s);
                    }
                    this.uploadingFiles.remove(ev.item);
                }, e => {
                    this.uploadingFiles.emmit(ev.item, 'upload_ex', e);
                    this.uploadingFiles.remove(ev.item);
                });
            }
            else if (ev.event == 'abort') {
                ev.item.uploader.cancel();
            }
            // if theres more items on queu grab next one
            else if (ev.event == 'REMOVE' && this.uploadingQueue.values.length) {
                var next = this.uploadingQueue.values[0];
                this.uploadingQueue.remove(next);
                this.uploadingFiles.set(next);
            }
        });
    }
    // store syncers
    eq(a, b) {
        return a.uid == b.uid;
    }
    sync(e, b) {
        if (e.event == 'ADD') {
            b.add(e.item);
        }
        else if (e.event == 'REMOVE') {
            b.remove(e.item);
        }
        else if (e.event == 'UPDATE') {
            b.emmit(e.item, 'UPDATE');
        }
    }
    // Getters
    get teams() {
        return this._teams;
    }
    get profile() {
        return this._profile;
    }
    get account() {
        return this._account;
    }
    get team() {
        return this._team;
    }
    get projects() {
        return this._projects;
    }
    get processingItems() {
        return this._processingItems;
    }
    get uploadingFiles() {
        return this._uploadingFiles;
    }
    get uploadingQueue() {
        return this._uploadingQueue;
    }
    get acl() {
        return this._acl;
    }
}
exports.FileDataService = FileDataService;
